module.exports = __webpack_public_path__ + "static/media/ski_station_default.299724ce.jpg";